import { useEffect } from "react";
import SignInForm from "./SignInForm";
import { useAuthContext } from "../_helper/Auth";
import { useLocation, useNavigate } from "react-router-dom";
import { MANDATORY_CHANGE_PASSWORD_PATH } from "../Routes/PrivateRoute";

export default function SignIn() {
  const {
    token,
    emailVerificationPending,
    passwordChangeRequired,
  } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();

  // Extract the from location from state
  const from = location.state?.from;
  useEffect(() => {
    if (!!token) {
      if (passwordChangeRequired) {
        navigate(MANDATORY_CHANGE_PASSWORD_PATH, { replace: true });
      } else if (emailVerificationPending) {
        navigate("/verify-email", { replace: true });
      } else {
        navigate(from || "/app", { replace: true });
      }
    }
  }, [
    token,
    passwordChangeRequired,
    emailVerificationPending,
    from,
    navigate,
  ]);

  return <SignInForm />;
}
